export default __webpack_public_path__ + "assets/fc3c518ee494aa1a708208cbba47be77.jpg";